import { get } from "lodash";
import {
  getPersonPageTitleQuery,
  getPositionPageTitleQuery,
  getTeamTitleQuery,
  getTagPageTitleQuery,
} from "src/queries/pageTitle.graphql";
import { getName } from "src/util/person";
import { groupTypeAsText } from "src/util/groupType";

export const PAGE_TITLE_CONFIGS = {
  personDetailPage: {
    query: getPersonPageTitleQuery,
    mapper: (data, id) => (!data ? `Person ${id}` : getName(data?.person)),
  },
  positionDetailPage: {
    query: getPositionPageTitleQuery,
    mapper: (data, id) =>
      !data ? `Position ${id}` : data?.position?.name || `Position ${id}`,
  },
  teamDetailPage: {
    query: getTeamTitleQuery,
    mapper: (data, id, groupTypes) => {
      const teamType = get(groupTypes, data?.team?.type, {
        name: data?.team?.type,
        noConfig: true,
      });
      return !data
        ? `Team ${id}`
        : `${data?.team?.name} [${groupTypeAsText(teamType)}]`;
    },
  },
  tagDetailPage: {
    query: getTagPageTitleQuery,
    mapper: (data, id) => {
      const tag = data?.tag?.[0];
      const displayValue = tag?.displayValue;
      const type = tag?.type;
      if (
        !tag ||
        displayValue === undefined ||
        displayValue === null ||
        displayValue === ""
      ) {
        return `Tag ${id}`;
      }
      return `${displayValue} [${type ?? ""}]`;
    },
  },
  dashboard: {
    query: getPersonPageTitleQuery,
    mapper: (data) => getName(data),
    isDashboard: true,
  },
};
